<template>
  <button
    class="bg-brand-green-400 hover:bg-brand-green-200 disabled:bg-brand-green-100 disabled:cursor-not-allowed text-white font-bold py-2 px-4 rounded uppercase"
    type="submit"
    :disabled="disabled"
    @click="$emit('click')"
  >
    Submit Review
  </button>
</template>

<script>
export default {
  emits: ["click"],
  props: {
    disabled: {
      default: true,
      required: false,
      type: Boolean,
    },
  },
};
</script>
